import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './app'

if (process.env.NODE_ENV === 'production') {
  require('react-hotjar').hotjar.initialize(576994, 6)
  require('./stores/analytics').AnalyticsStore.initialize('UA-165289151-2')
}

ReactDOM.render(React.createElement(App), document.getElementById('root'))
